export default __webpack_public_path__ + "static/media/close_black_24dp.952e1238.svg";